import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "data-container" }
const _hoisted_2 = {
  id: "data-chart",
  class: "breadcrumb"
}
const _hoisted_3 = { class: "breadcrumb-left" }
const _hoisted_4 = { class: "header-meta-group" }
const _hoisted_5 = { class: "meta-value" }
const _hoisted_6 = { class: "breadcrumb-actions" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "export-spinner"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "filters-section" }
const _hoisted_12 = { class: "filters-row" }
const _hoisted_13 = { class: "filter-group" }
const _hoisted_14 = { class: "range-btn-group" }
const _hoisted_15 = { class: "filter-group" }
const _hoisted_16 = ["max"]
const _hoisted_17 = ["min", "max"]
const _hoisted_18 = { class: "filter-group" }
const _hoisted_19 = { class: "range-btn-group" }
const _hoisted_20 = { class: "filter-group" }
const _hoisted_21 = { class: "toggle-switch" }
const _hoisted_22 = { class: "filter-group" }
const _hoisted_23 = {
  key: 0,
  class: "filter-summary"
}
const _hoisted_24 = { class: "summary-text" }
const _hoisted_25 = { class: "stats-section" }
const _hoisted_26 = { class: "stats-grid" }
const _hoisted_27 = { class: "stat-card" }
const _hoisted_28 = { class: "stat-content" }
const _hoisted_29 = { class: "stat-value" }
const _hoisted_30 = { class: "stat-card" }
const _hoisted_31 = { class: "stat-content" }
const _hoisted_32 = { class: "stat-card" }
const _hoisted_33 = { class: "stat-content" }
const _hoisted_34 = { class: "stat-value" }
const _hoisted_35 = { class: "stat-card" }
const _hoisted_36 = { class: "stat-content" }
const _hoisted_37 = { class: "stat-value" }
const _hoisted_38 = { class: "content-wrapper" }
const _hoisted_39 = { class: "notifications-container" }
const _hoisted_40 = {
  key: 0,
  class: "loading-placeholder"
}
const _hoisted_41 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_42 = {
  key: 2,
  class: "notifications-list"
}
const _hoisted_43 = { class: "notification-header" }
const _hoisted_44 = { class: "notification-title" }
const _hoisted_45 = { class: "notification-meta" }
const _hoisted_46 = { class: "meta-date" }
const _hoisted_47 = {
  key: 0,
  class: "meta-graph"
}
const _hoisted_48 = {
  key: 1,
  class: "meta-user"
}
const _hoisted_49 = { class: "notification-actions" }
const _hoisted_50 = ["onClick", "title"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "notification-body" }
const _hoisted_53 = { class: "notification-message" }
const _hoisted_54 = {
  key: 0,
  class: "admin-message"
}
const _hoisted_55 = {
  key: 1,
  class: "notification-payload"
}
const _hoisted_56 = { class: "notification-footer" }
const _hoisted_57 = { class: "notification-type" }
const _hoisted_58 = { class: "type-badge" }
const _hoisted_59 = {
  key: 0,
  class: "notification-actions-footer"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 3,
  class: "pagination"
}
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "pagination-info" }
const _hoisted_64 = ["disabled"]

import { ref, computed, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";
import axios from "@/axiosInstance";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

/* ───────── TYPES ───────── */
interface Notification {
  id: number;
  user_id: number;
  username: string | null;
  email: string | null;
  graph_id: number | null;
  graph_name: string | null;
  graph_status: string | null;
  type: string;
  title: string;
  message: string;
  admin_message?: string;
  severity: string;
  payload: any;
  createdAt: string;
  is_read: boolean;
}

/* ───────── STATE ───────── */

export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsPage',
  setup(__props) {

const router = useRouter();
const toast = useToast();

const notifications = ref<Notification[]>([]);
const loading = ref(false);
const exporting = ref(false);
const totalCount = ref(0);
const unreadCount = ref(0);

// Filtri
const scope = ref<"all" | "unread">("unread");
const includeRead = ref(true);
const selectedSeverity = ref("all");
const timeRange = ref<"day" | "week" | "month" | "all" | "custom">("week");
const startDate = ref("");
const endDate = ref("");

// Paginazione
const limit = ref(20);
const offset = ref(0);

// Date utilities
const today = ref(new Date().toISOString().split("T")[0]);

/* ───────── COMPUTED ───────── */
const queryParams = computed(() => {
  // console.log("selectedSeverity:", selectedSeverity.value);
  const params: any = {
    scope: scope.value,
    include_read: includeRead.value ? "1" : "0",
    limit: limit.value,
    offset: offset.value,
    severity:
      selectedSeverity.value !== "all" ? selectedSeverity.value : undefined,
  };

  // Gestione date in ordine di priorità:
    // 1. Se c'è un range predefinito (non "all" e non "custom"), usa quello
    // 2. Se ci sono date custom, usa quelle
    // 3. Se timeRange è "all", non inviare date
  
  if (timeRange.value !== "all") {
    if (timeRange.value !== "custom") {
      // Range predefinito (day, week, month)
      const range = calculateDateRange(timeRange.value);
      params.start_date = range.start;
      params.end_date = range.end;
    } else if (startDate.value && endDate.value) {
      // Date custom
      params.start_date = startDate.value;
      params.end_date = endDate.value;
    }
    // Se timeRange è "custom" ma non ci sono date, non inviare nulla
  }
  
  return params;
});

const activeFilterSummary = computed(() => {
  if (timeRange.value === "custom" && startDate.value && endDate.value) {
    return `Periodo: ${formatDateDisplay(
      startDate.value
    )} - ${formatDateDisplay(endDate.value)}`;
  }

  switch (timeRange.value) {
    case "day":
      return "Oggi";
    case "week":
      return "Ultima settimana";
    case "month":
      return "Ultimo mese";
    case "all":
      return "Tutto il periodo";
    default:
      return null;
  }
});

const hasActiveFilters = computed(() => {
  return (
    scope.value !== "all" ||
    !includeRead.value ||
    selectedSeverity.value !== "all" ||
    timeRange.value !== "week" ||
    startDate.value !== "" ||
    endDate.value !== ""
  );
});

const errorCount = computed(() => {
  return notifications.value.filter((n) => n.severity === "error").length;
});

const oldestDate = computed(() => {
  if (notifications.value.length === 0) return null;
  return notifications.value.reduce((oldest, notification) => {
    const date = new Date(notification.createdAt);
    return date < oldest ? date : oldest;
  }, new Date(notifications.value[0].createdAt));
});

/* ───────── METHODS ───────── */
function calculateDateRange(range: "day" | "week" | "month") {
  const end = new Date();
  const start = new Date();

  switch (range) {
    case "day":
      start.setDate(end.getDate() - 1);
      break;
    case "week":
      start.setDate(end.getDate() - 7);
      break;
    case "month":
      start.setMonth(end.getMonth() - 1);
      break;
  }

  return {
    start: start.toISOString().split("T")[0],
    end: end.toISOString().split("T")[0],
  };
}

function setTimeRange(range: "day" | "week" | "month" | "all" | "custom") {
  timeRange.value = range;

  if (range === "all") {
    startDate.value = "";
    endDate.value = "";
  } else if (range !== "custom") {
    const dates = calculateDateRange(range);
    startDate.value = dates.start;
    endDate.value = dates.end;
  }

  loadNotifications();
}

function applyDateFilter() {
  if (startDate.value && endDate.value) {
    // Quando l'utente modifica manualmente le date, 
    // imposta timeRange a "custom"
    timeRange.value = "custom";
    loadNotifications();
  } else if (!startDate.value && !endDate.value) {
    // Se l'utente cancella entrambe le date, 
    // torna al range predefinito "week"
    timeRange.value = "day";
    const dates = calculateDateRange("day");
    startDate.value = dates.start;
    endDate.value = dates.end;
    loadNotifications();
  }
}

function resetDateFilter() {
  startDate.value = "";
  endDate.value = "";
  timeRange.value = "day";

  // Carica le date del range predefinito
  const dates = calculateDateRange("day");
  startDate.value = dates.start;
  endDate.value = dates.end;

  loadNotifications();
}

function clearAllFilters() {
  scope.value = "all";
  includeRead.value = true;
  selectedSeverity.value = "all";
  timeRange.value = "day";
   // Reset date con il range predefinito
  const dates = calculateDateRange("day");
  startDate.value = dates.start;
  endDate.value = dates.end;
  loadNotifications();
}

async function loadNotifications() {
  try {
    loading.value = true;

    const params = new URLSearchParams();
    // console.log("queryparams.value", queryParams.value);
    Object.entries(queryParams.value).forEach(([key, value]) => {
      if (value !== undefined) {
        params.append(key, String(value));
      }
    });
    console.log("Caricamento notifiche con params:", params);
    const response = await axios.get(`/notifications?${params.toString()}`);

    notifications.value = response.data.items;
    console.log("notifiche caricate:", notifications.value);
    totalCount.value = response.data.totalCount || notifications.value.length;
    unreadCount.value = response.data.unreadCount || 0;
  } catch (error) {
    console.error("Errore nel caricamento notifiche:", error);
    toast.error("Errore nel caricamento delle notifiche", {
      position: "top-right",
    });
  } finally {
    loading.value = false;
  }
}

async function toggleRead(notification: Notification) {
  try {
    const newReadStatus = !notification.is_read;
    // console.log("newReadStatus:", newReadStatus);

    const resReadUnread = await axios.put(
      `/notifications/${notification.id}/read`,
      {
        is_read: newReadStatus,
      }
    );
    // console.log("filtrolettenonlette", resReadUnread);
    // Aggiorna localmente
    notification.is_read = newReadStatus;

    // Aggiorna contatori
    if (newReadStatus) {
      unreadCount.value = Math.max(0, unreadCount.value - 1);
    } else {
      unreadCount.value += 1;
    }

    // Se siamo in modalità "unread" e segniamo come letta, rimuovi dalla lista
    if (scope.value === "unread") {
      notifications.value = notifications.value.filter(
        (n) => n.id !== notification.id
      );
    }
    if (resReadUnread.status === 200) {
      toast.success(
        `Notifica ${
          newReadStatus ? "segna come letta" : "segna come non letta"
        }`,
        {
          position: "top-right",
          duration: 2000,
        }
      );
    }
  } catch (error) {
    console.error("Errore nell'aggiornamento notifica:", error);
    toast.error("Errore nell'aggiornamento della notifica", {
      position: "top-right",
    });
  }
}

async function markAllAsRead() {
  try {
    await axios.post("/notifications/read-all");

    // Aggiorna tutte le notifiche localmente
    notifications.value.forEach((notification) => {
      notification.is_read = true;
    });

    // Resetta contatore non lette
    unreadCount.value = 0;

    toast.success("Tutte le notifiche segnate come lette", {
      position: "top-right",
      duration: 2000,
    });
  } catch (error) {
    console.error("Errore nel segnare tutte come lette:", error);
    toast.error("Errore nel segnare tutte come lette", {
      position: "top-right",
    });
  }
}

async function deleteNotification(id: number) {
  if (!confirm("Sei sicuro di voler eliminare questa notifica?")) return;

  try {
    await axios.delete(`/notifications/${id}`);

    // Rimuovi localmente
    notifications.value = notifications.value.filter((n) => n.id !== id);

    toast.success("Notifica eliminata", {
      position: "top-right",
      duration: 2000,
    });
  } catch (error) {
    console.error("Errore nell'eliminazione notifica:", error);
    toast.error("Errore nell'eliminazione della notifica", {
      position: "top-right",
    });
  }
}

function goToDevice(graphId: number) {
  router.push(`/data/${graphId}`);
}

function formatDate(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatDateShort(date: Date) {
  return date.toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function formatDateDisplay(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function formatPayload(payload: any) {
  // console.log("formatPayload called with:", payload);
  
  if (!payload) return "Nessun dettaglio disponibile";
  
  let parsedPayload;
  
  // Parse JSON string if needed
  if (typeof payload === "string") {
    try {
      parsedPayload = JSON.parse(payload);
    } catch {
      return payload;
    }
  } else {
    parsedPayload = payload;
  }
  
  // Custom formatting for specific payload structures
  if (parsedPayload && typeof parsedPayload === "object") {
    return formatObjectForDisplay(parsedPayload);
  }
  
  return JSON.stringify({...parsedPayload, }, null, 2);
}

function formatObjectForDisplay(obj: any): string {
  const sections: string[] = [];
  
  // Device section
  if (obj.graphId !== undefined) {
    sections.push(`DISPOSITIVO`);
    sections.push(`   Numero: ${obj.graphId}`);
  }

  if (obj.graph_name !== undefined) {
    sections.push(`   Nome: ${obj.graph_name}`);
  }
  
  // Status section
  if (obj.is_static !== undefined) {
    const status = obj.is_static ? "Statico" : "In movimento";
    sections.push(`   Stato: ${status}`);
  }
  
  // Add separator if we have both device info and user info
  if ((obj.graphId !== undefined || obj.is_static !== undefined) && 
      (obj.byUserId !== undefined || obj.byUserUsername !== undefined || obj.byUserEmail !== undefined)) {
    sections.push(`\n──────────────\n`);
  }
  
  // User credentials section
  if (obj.byUserId !== undefined || obj.byUserUsername !== undefined || obj.byUserEmail !== undefined) {
    sections.push(`CREDENZIALI`);
    
    if (obj.byUserId !== undefined) {
      sections.push(`   Numero ID: ${obj.byUserId}`);
    }
    
    if (obj.byUserUsername !== undefined) {
      sections.push(`   Username: ${obj.byUserUsername}`);
    }
    
    if (obj.byUserEmail !== undefined) {
      sections.push(`   Email: ${obj.byUserEmail}`);
    }
  }
  
  // Handle other fields that might be present
  const knownFields = ['graphId', 'is_static', 'byUserId', 'byUserUsername', 'byUserEmail', 
                      'userId', 'username', 'email', 'graph_id', 'user_id', 'graph_name'];
  
  const otherFields = Object.keys(obj).filter(key => !knownFields.includes(key));
  
  if (otherFields.length > 0) {
    if (sections.length > 0 && !sections[sections.length - 1].includes('──────────────')) {
      sections.push(`\n──────────────\n`);
    }
    
    sections.push(`🔧 ALTRI DETTAGLI`);
    
    otherFields.forEach(key => {
      const value = obj[key];
      const formattedKey = formatKey(key);
      sections.push(`   ${formattedKey}: ${formatValue(value)}`);
    });
  }
  
  return sections.join('\n');
}

function formatKey(key: string): string {
  const keyMap: Record<string, string> = {
    'graphId': 'Device ID',
    'graph_id': 'Device ID',
    'is_static': 'Modalità',
    'byUserId': 'Utente ID',
    'user_id': 'Utente ID',
    'userId': 'Utente ID',
    'byUserUsername': 'Username',
    'username': 'Username',
    'byUserEmail': 'Email',
    'email': 'Email',
    'temperature': 'Temperatura',
    'humidity': 'Umidità',
    'voltage': 'Voltaggio',
    'min': 'Minimo',
    'max': 'Massimo',
    'entity_id': 'Entità ID',
    'kind': 'Tipo',
    'metric': 'Metrica',
    'subtype': 'Sottotipo',
    'measurement_ts': 'Data misurazione',
    'created_at': 'Creato il',
    'updated_at': 'Aggiornato il'
  };
  
  return keyMap[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

function formatValue(value: any): string {
  if (value === null || value === undefined) return 'N/A';
  
  if (typeof value === 'boolean') {
    return value ? 'Sì' : 'No';
  }
  
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  
  // Check if it's a date string
  if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) {
    try {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }
    } catch (e) {
      // Not a valid date, continue
    }
  }
  
  return String(value);
}


function getSeverityLabel(severity: string) {
  const labels: Record<string, string> = {
    success: "Successo",
    info: "Informazione",
    warning: "Avviso",
    error: "Errore",
  };
  return labels[severity] || severity;
}

function getEmptyStateMessage() {
  if (hasActiveFilters.value) {
    return "Nessuna notifica corrisponde ai filtri selezionati.";
  }
  return scope.value === "unread"
    ? "Non ci sono notifiche non lette"
    : "Non ci sono notifiche da visualizzare";
}

function previousPage() {
  offset.value = Math.max(0, offset.value - limit.value);
  loadNotifications();
}

function nextPage() {
  if (offset.value + limit.value < totalCount.value) {
    offset.value += limit.value;
    loadNotifications();
  }
}

/* ───────── PDF EXPORT ───────── */
async function exportToPDF() {
  try {
    exporting.value = true;

    // Crea un nuovo documento PDF
    const doc = new jsPDF();

    // Titolo
    doc.setFontSize(20);
    doc.text("Report Notifiche", 14, 22);

    // Informazioni filtro
    doc.setFontSize(10);
    doc.setTextColor(100);
    let filterInfo = `Generato il: ${new Date().toLocaleDateString("it-IT")}`;
    if (activeFilterSummary.value) {
      filterInfo += ` | Filtro: ${activeFilterSummary.value}`;
    }
    doc.text(filterInfo, 14, 32);

    // Statistiche
    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.text(`Totale notifiche: ${notifications.value.length}`, 14, 42);
    doc.text(`Non lette: ${unreadCount.value}`, 14, 50);
    doc.text(`Errori: ${errorCount.value}`, 14, 58);

    // Tabella notifiche
    const tableData = notifications.value.map((notification, index) => [
      index + 1,
      formatDate(notification.createdAt),
      notification.title,
      getSeverityLabel(notification.severity),
      notification.is_read ? "Letti" : "Non letti",
      notification.graph_name || "N/A",
      notification.message.substring(0, 50) +
        (notification.message.length > 50 ? "..." : ""),
    ]);

    // @ts-ignore - jspdf-autotable types
    autoTable(doc, {
      startY: 65,
      head: [
        [
          "#",
          "Data/Ora",
          "Titolo",
          "Tipo di avviso",
          "Stato",
          "Dispositivo",
          "Messaggio",
        ],
      ],
      body: tableData,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 40 },
        3: { cellWidth: 20 },
        4: { cellWidth: 15 },
        5: { cellWidth: 25 },
        6: { cellWidth: 50 },
      },
    });

    // Aggiungi dettagli per ogni notifica
    const finalY = (doc as any).lastAutoTable.finalY + 10;
    doc.setFontSize(14);
    doc.text("Dettaglio Notifiche", 14, finalY);

    let yPos = finalY + 10;

    notifications.value.forEach((notification, index) => {
      if (yPos > 280) {
        doc.addPage();
        yPos = 20;
      }

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(`${index + 1}. ${notification.title}`, 14, yPos);

      yPos += 6;
      doc.setFont("helvetica", "normal");
      doc.text(`Data: ${formatDate(notification.createdAt)}`, 14, yPos);

      yPos += 6;
      doc.text(
        `Tipo di avviso: ${getSeverityLabel(notification.severity)} | Stato: ${
          notification.is_read ? "Letta" : "Non letta"
        }`,
        14,
        yPos
      );

      yPos += 6;
      doc.text(`Dispositivo: ${notification.graph_name || "N/A"}`, 14, yPos);

      yPos += 6;
      doc.setFont("helvetica", "bold");
      doc.text("Messaggio:", 14, yPos);

      yPos += 6;
      doc.setFont("helvetica", "normal");
      const messageLines = doc.splitTextToSize(notification.message, 180);
      doc.text(messageLines, 14, yPos);

      yPos += messageLines.length * 5 + 4;

      if (
        notification.admin_message &&
        notification.admin_message !== notification.message
      ) {
        doc.setFont("helvetica", "bold");
        doc.text("Messaggio Amministrativo:", 14, yPos);

        yPos += 6;
        doc.setFont("helvetica", "normal");
        const adminLines = doc.splitTextToSize(notification.admin_message, 180);
        doc.text(adminLines, 14, yPos);

        yPos += adminLines.length * 5 + 4;
      }

      yPos += 8;
    });

    // Salva il PDF
    const fileName = `notifiche_${new Date().toISOString().split("T")[0]}.pdf`;
    doc.save(fileName);

    toast.success("PDF esportato con successo", {
      position: "top-right",
      duration: 3000,
    });
  } catch (error) {
    console.error("Errore nell'esportazione PDF:", error);
    toast.error("Errore nell'esportazione PDF", { position: "top-right" });
  } finally {
    exporting.value = false;
  }
}

/* ───────── WATCHERS ───────── */
watch([scope, includeRead, selectedSeverity, timeRange, startDate, endDate], () => {
  // console.log("selected severity in watcher:", selectedSeverity.value);
  // non c'è bisogno di aggiornare qui i queryParams perché è una computed
  // const params: any = {
  //   scope: scope.value,
  //   include_read: includeRead.value ? "1" : "0",
  //   limit: limit.value,
  //   offset: offset.value,
  //   severity:
  //     selectedSeverity.value !== "all" ? selectedSeverity.value : undefined,
  // };
  offset.value = 0; // Reset paginazione quando cambiano i filtri
  loadNotifications();
});

/* ───────── LIFECYCLE ───────── */
onMounted(() => {
  // Imposta il range predefinito a questa settimana
  const dates = calculateDateRange("day");
  startDate.value = dates.start;
  endDate.value = dates.end;

  loadNotifications();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "device-name" }, "Reports", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "meta-divider" }, "•", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "meta-label" }, "Totale", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(totalCount.value), 1),
          _cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "meta-label",
            style: {"margin-left":"8px"}
          }, "Non lette", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["meta-value", { 'unread-badge': unreadCount.value > 0 }])
          }, _toDisplayString(unreadCount.value), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-export",
          onClick: exportToPDF,
          disabled: notifications.value.length === 0 || exporting.value
        }, [
          (exporting.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "📄 Esporta PDF"))
        ], 8, _hoisted_7),
        _createElementVNode("button", {
          class: "btn btn-mark-all",
          onClick: markAllAsRead,
          disabled: unreadCount.value === 0
        }, " Segna tutte come lette ", 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "filter-label" }, "Periodo:", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: timeRange.value === 'day' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setTimeRange('day')))
            }, " Oggi ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: timeRange.value === 'week' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setTimeRange('week')))
            }, " Settimana ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: timeRange.value === 'month' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setTimeRange('month')))
            }, " Mese ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: timeRange.value === 'all' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (setTimeRange('all')))
            }, " Tutto ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "filter-label" }, "Da:", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((startDate).value = $event)),
            max: endDate.value,
            class: "date-input",
            onChange: applyDateFilter
          }, null, 40, _hoisted_16), [
            [_vModelText, startDate.value]
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "filter-label" }, "A:", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endDate).value = $event)),
            min: startDate.value,
            max: today.value,
            class: "date-input",
            onChange: applyDateFilter
          }, null, 40, _hoisted_17), [
            [_vModelText, endDate.value]
          ]),
          _createElementVNode("button", {
            class: "btn btn-small btn-reset-date",
            onClick: resetDateFilter
          }, " Reset ")
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "filter-label" }, "Filtra:", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: scope.value === 'all' }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (scope.value = 'all'))
            }, " Tutte ", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["range-btn", { active: scope.value === 'unread' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (scope.value = 'unread'))
            }, " Non lette ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "filter-label" }, "Mostra lette:", -1)),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: 'toggle-read',
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((includeRead).value = $event)),
              onChange: loadNotifications
            }, null, 544), [
              [_vModelCheckbox, includeRead.value]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              for: 'toggle-read',
              class: "toggle-slider"
            }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "filter-label" }, "Tipo di report:", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "custom-select",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedSeverity).value = $event)),
            onChange: loadNotifications
          }, [...(_cache[20] || (_cache[20] = [
            _createStaticVNode("<option value=\"all\" data-v-336a612b>Tutti</option><option value=\"success\" data-v-336a612b>Successo</option><option value=\"info\" data-v-336a612b>Informazione</option><option value=\"warning\" data-v-336a612b>Avviso</option><option value=\"error\" data-v-336a612b>Errore</option>", 5)
          ]))], 544), [
            [_vModelSelect, selectedSeverity.value]
          ])
        ])
      ]),
      (activeFilterSummary.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(activeFilterSummary.value), 1),
            _createElementVNode("button", {
              class: "btn-clear-filter",
              onClick: clearAllFilters
            }, " ✕ Rimuovi filtri ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(notifications.value.length), 1),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "stat-label" }, "Reports totali", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              class: _normalizeClass(["stat-value", { 'unread-stat': unreadCount.value > 0 }])
            }, _toDisplayString(unreadCount.value), 3),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "stat-label" }, "Non lette", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(errorCount.value), 1),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "stat-label" }, "Errori", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(oldestDate.value ? formatDateShort(oldestDate.value) : "N/A"), 1),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "stat-label" }, "Dal", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("div", { class: "loading-spinner" }, null, -1),
              _createElementVNode("span", null, "Caricamento reports...", -1)
            ]))]))
          : (notifications.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "empty-icon" }, "📭", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Nessuna notifica", -1)),
                _createElementVNode("p", null, _toDisplayString(getEmptyStateMessage()), 1),
                (hasActiveFilters.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-small",
                      onClick: clearAllFilters
                    }, " Rimuovi filtri "))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: notification.id,
                    class: _normalizeClass(["notification-card", {
              unread: !notification.is_read,
              read: notification.is_read,
              [`severity-${notification.severity}`]: true,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["notification-badge", notification.severity])
                      }, null, 2),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("h4", null, _toDisplayString(notification.title), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(formatDate(notification.createdAt)), 1),
                          (notification.graph_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, " • " + _toDisplayString(notification.graph_name), 1))
                            : _createCommentVNode("", true),
                          (notification.username)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, " • " + _toDisplayString(notification.username), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("button", {
                          class: "action-btn",
                          onClick: _withModifiers(($event: any) => (toggleRead(notification)), ["stop"]),
                          title: 
                    notification.is_read
                      ? 'Segna come non letta'
                      : 'Segna come letta'
                  
                        }, _toDisplayString(notification.is_read ? "📭" : "📬"), 9, _hoisted_50),
                        _createElementVNode("button", {
                          class: "action-btn delete-btn",
                          onClick: _withModifiers(($event: any) => (deleteNotification(notification.id)), ["stop"]),
                          title: "Elimina"
                        }, " 🗑️ ", 8, _hoisted_51)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("p", _hoisted_53, _toDisplayString(notification.message), 1),
                      (
                  notification.admin_message &&
                  notification.admin_message !== notification.message
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "admin-label" }, "Messaggio amministrativo:", -1)),
                            _createElementVNode("p", null, _toDisplayString(notification.admin_message), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (notification.payload)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("details", null, [
                              _cache[30] || (_cache[30] = _createElementVNode("summary", null, "Dettagli", -1)),
                              _createElementVNode("pre", null, _toDisplayString(formatPayload(notification.payload)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(notification.type), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["severity-badge", notification.severity])
                        }, _toDisplayString(getSeverityLabel(notification.severity)), 3)
                      ]),
                      (notification.graph_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (notification.graph_id)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-small",
                                  onClick: _withModifiers(($event: any) => (goToDevice(notification.graph_id)), ["stop"])
                                }, " Vai al dispositivo ", 8, _hoisted_60))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ])),
        (notifications.value.length > 0 && totalCount.value > limit.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("button", {
                class: "pagination-btn",
                disabled: offset.value === 0,
                onClick: previousPage
              }, " ← Precedenti ", 8, _hoisted_62),
              _createElementVNode("div", _hoisted_63, _toDisplayString(offset.value + 1) + " - " + _toDisplayString(Math.min(offset.value + limit.value, totalCount.value)) + " di " + _toDisplayString(totalCount.value), 1),
              _createElementVNode("button", {
                class: "pagination-btn",
                disabled: offset.value + limit.value >= totalCount.value,
                onClick: nextPage
              }, " Successivi → ", 8, _hoisted_64)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})